module.exports = __webpack_public_path__ + "media/goforajourney/img/italy-card-5fb1ebe388d0562a8c4b66a39196a596.webp";